"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("th", _vm._g(_vm._b({
    ref: "thDom",
    staticClass: "resize-table-th",
    attrs: {
      width: _vm.column?.width
    }
  }, "th", _vm.$attrs, false), _vm.$listeners), [_vm._t("default"), _vm.column?.width ? _c("vue-draggable-reziable", {
    staticClass: "table-draggable-handle",
    attrs: {
      axis: "x",
      w: 5,
      x: _vm.column.width,
      z: 1,
      draggable: "",
      resizable: false
    },
    on: {
      dragging: _vm.handleDragging
    },
    nativeOn: {
      click: function ($event) {
        $event.stopPropagation();
      }
    }
  }) : _vm._e()], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;